import { arraysEqual } from "@/lib/utils";
import { GetOneExpeditionResponseDto } from "@/types/api/api-types";
import {
  DeliveryFormData,
  DeliveryFormOcrData,
} from "@/types/forms/home/cotationDeliveryForm.form";

type Props = {
  expedition: GetOneExpeditionResponseDto;
  data: DeliveryFormData;
};

export const updateValidatedCotationPayload = ({ expedition, data }: Props) => {
  const payload: any = {};

  const deliveryContent = data.deliveryContent.map((content) => ({
    wineName: content.wineName,
    year: content.year === 0 ? null : content.year,
    alcoholPercent: content.alcoholPercent,
    volume: content.volume,
    color: content.color,
    numberOfBottles: content.quantity,
    unitPrice: content.price,
  }));

  if (data.removedFilesId && data.removedFilesId.length > 0) {
    payload.removedFilesId = data.removedFilesId;
  }
  if (data.newFilesId && data.newFilesId.length > 0) {
    payload.newFilesId = data.newFilesId;
  }

  if (data.lastName !== expedition.deliveryInfo?.lastName) {
    payload.lastName = data.lastName;
  }
  if (data.firstName !== expedition.deliveryInfo?.firstName) {
    payload.firstName = data.firstName;
  }
  if (data.email !== expedition.deliveryInfo?.email) {
    payload.email = data.email;
  }
  if (data.phone !== expedition.deliveryInfo?.phone) {
    payload.phone = data.phone;
  }
  if (data.street !== expedition.deliveryInfo?.street) {
    payload.street = data.street;
  }
  if (data.postalCode !== expedition.deliveryInfo?.postalCode) {
    payload.postalCode = data.postalCode;
  }
  if (data.city !== expedition.deliveryInfo?.city) {
    payload.city = data.city;
  }
  if (data.stateOrProvinceCode !== expedition.deliveryInfo?.state) {
    payload.stateOrProvinceCode = data.stateOrProvinceCode;
  }
  if (data.customId !== expedition.quotation?.customId) {
    payload.customId = data.customId;
  }
  if (data.company !== expedition.deliveryInfo?.company) {
    payload.company = data.company;
  }
  if (data.billingEntityId !== expedition.expeditionBillingDetail?.billingEntityId) {
    payload.billingEntityId = data.billingEntityId;
  }
  if (data.pickUpLocationId !== expedition.pickupInfo?.pickupLocation?.id) {
    payload.pickUpLocationId = data.pickUpLocationId;
  }
  if (data.dapOption !== expedition.expeditionOptions?.dapOption) {
    payload.dapOption = data.dapOption;
  }
  if (data.express !== expedition.expeditionOptions?.express) {
    payload.express = data.express;
  }
  if (data.insurance !== expedition.expeditionOptions?.insurance) {
    payload.insurance = data.insurance;
  }

  if (
    data.reference !== expedition.expeditionBillingDetail?.reference &&
    !(!data.reference && !expedition.expeditionBillingDetail?.reference)
  ) {
    payload.reference = data.reference ? data.reference : null;
  }
  if ("comment" in data && data.comment !== expedition.deliveryInfo?.comment) {
    payload.comment = data.comment;
  }
  if (!arraysEqual(deliveryContent, expedition.quotation?.deliveryContent || [])) {
    payload.deliveryContent = deliveryContent;
  }

  if (!arraysEqual(data.woodBoxes, expedition.quotation?.quotationWoodBox || [])) {
    payload.woodBoxes = data.woodBoxes;
  }

  return payload;
};

type PropsOcr = {
  expedition: GetOneExpeditionResponseDto;
  data: DeliveryFormOcrData;
};

export const updateValidatedCotationOcrPayload = ({ expedition, data }: PropsOcr) => {
  const payload: any = {};

  if (data.removedFilesId && data.removedFilesId.length > 0) {
    payload.removedFilesId = data.removedFilesId;
  }
  if (data.newFilesId && data.newFilesId.length > 0) {
    payload.newFilesId = data.newFilesId;
  }
  if (data.invoiceFileId) {
    payload.invoiceFileId = data.invoiceFileId;
  }

  if (data.billingEntityId !== expedition.expeditionBillingDetail?.billingEntityId) {
    payload.billingEntityId = data.billingEntityId;
  }
  if (data.pickUpLocationId !== expedition.pickupInfo?.pickupLocation?.id) {
    payload.pickUpLocationId = data.pickUpLocationId;
  }
  if (data.dapOption !== expedition.expeditionOptions?.dapOption) {
    payload.dapOption = data.dapOption;
  }
  if (data.express !== expedition.expeditionOptions?.express) {
    payload.express = data.express;
  }
  if (data.insurance !== expedition.expeditionOptions?.insurance) {
    payload.insurance = data.insurance;
  }
  if (
    data.reference !== expedition.expeditionBillingDetail?.reference &&
    (data.reference || expedition.expeditionBillingDetail?.reference)
  ) {
    payload.reference = data.reference ? data.reference : null;
  }
  if (
    data.comment !== expedition.deliveryInfo?.comment &&
    (data.comment || expedition.deliveryInfo?.comment)
  ) {
    payload.comment = data.comment;
  }

  return payload;
};
